import RoundedButton from './RoundedButton'

function SuggestedButtonGhost() {
  return (
    <RoundedButton
        state='ghost'
        onClick={() => {}}
        width={116}
    ></RoundedButton>
  )
}

export default SuggestedButtonGhost